<template>
  <section class="record" @click="goPrescriptionDetail(medicalRecord)">
    <div class="record__info">
      <div class="flex align-center">
        <div class="avata">
          <img :src="medicalRecord.avatar | imgUrl" alt="" />
        </div>
        <div class="flex-1 ml10">
          <div class="mb10 flex align-center">
            <h1 class="name">{{ medicalRecord.name }}</h1>
            <van-tag color="#7EA4BA" text-color="#fff">{{ memberTypes[medicalRecord.memberType] }}</van-tag>
          </div>
          <p class="mb10">病历本号：{{ medicalRecord.recordNo }}</p>
          <p>性别：{{ medicalRecord.sex | sex }}</p>
        </div>
      </div>
      <div class="record__label">病历本</div>
      <div class="record__logo">
        <img :src="require('@/assets/imgs/record-logo.png')" alt="" />
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { Tag } from '@zyf2e/capui-mobile';
Vue.use(Tag);
export default {
  props: {
    medicalRecord: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      STATUS_MAP: { EXPIRED: 'EXPIRED' },
      memberTypes: ['本人', '父母', '子女', '配偶', '其他']
    };
  },
  methods: {
    // eslint-disable-next-line class-methods-use-this
    goPrescriptionDetail({ archiveId }) {
      this.$router.push({
        path: '/record-list',
        query: { archiveId }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@gray-3: #ebebeb; //二级边框
@gray-6: #adadad; //次要文字
@gray-7: #707070; //常规文字
@font-size-sm: 12px;
@font-size-md: 14px;
@font-size-lg: 18px;
.record {
  background-color: white;
  font-size: @font-size-md;
  margin-bottom: 10px;
  border-radius: 8px;

  &__info {
    position: relative;
    padding: 16px 0 20px 16px;
    background: linear-gradient(136deg, #fcfcff 0%, #fafcff 100%, #eff7ff 100%);
    color: #595959;
    border-radius: 8px;
    .avata {
      height: 48px;
      flex: 0 0 48px;
      margin-right: 12px;
      img {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        display: block;
      }
    }
    .name {
      color: #262626;
      font-size: @font-size-lg;
      margin-right: 8px;
      font-weight: bold;
    }
    .van-tag {
      padding: 2px 4px;
      font-size: 12px;
      line-height: 12px;
    }
    .record__label {
      width: 54px;
      height: 22px;
      background: #edf5ff;
      border-radius: 0px 8px 0px 8px;
      color: #1e8dff;
      position: absolute;
      top: 0;
      right: 0;
      text-align: center;
      line-height: 22px;
    }
    .record__logo {
      position: absolute;
      bottom: 0;
      right: 0;
      height: 66px;
      width: 95px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .mb10 {
    margin-bottom: 10px;
  }
}
</style>
